import { SimplifiedMeasurementChecklistMeasuresDTO } from '@library/dto/checklist/measure/simplified/simplified-measurement-checklist-measures.dto';
import { SimplifiedMeasurementChecklistStatusDTO } from '@library/dto/checklist/measure/simplified/simplified-measurement-checklist-status.dto';
import { SERVER_API_URL } from '@one/app/app.constants';
import {
  saveSimplifiedMeasuresMarkedAsNotApplicableSuccess,
  saveSimplifiedMeasuresSuccess,
} from '@one/app/pages/isp/pages/inspection/pages/id/shared/services/store/isp-inspection-id-workflow-store.actions';
import { InspectionId } from '@one/app/pages/isp/shared/models/isp-inspection.models';
import { ActionsQueueService } from '@one/app/shared/services/actions-queue/actions-queue.service';
import { DatabaseService } from '@one/app/shared/services/database/database-inspection.service';
import { IStoreState } from '@one/app/store/store.models';
import { HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class SimplifiedMeasurementSyncService {
  private readonly _databaseService = inject(DatabaseService);
  private readonly _actionsQueueService = inject(ActionsQueueService);
  private readonly _store = inject(Store<IStoreState>);

  public async commitMeasuresLocally(
    inspectionId: InspectionId,
    simplifiedMeasures: SimplifiedMeasurementChecklistMeasuresDTO
  ): Promise<void> {
    await this._databaseService.saveSimplifiedMeasures(inspectionId, simplifiedMeasures);
    this._store.dispatch(saveSimplifiedMeasuresSuccess({ simplifiedMeasures }));
  }

  public async scheduleMeasuresSync(
    inspectionId: InspectionId,
    simplifiedMeasures: SimplifiedMeasurementChecklistMeasuresDTO
  ): Promise<void> {
    const url = `${SERVER_API_URL}api/inspections/${inspectionId}/simplified-measurement/measurement`;
    const request = new HttpRequest<SimplifiedMeasurementChecklistMeasuresDTO>('PUT', url, simplifiedMeasures);

    await this._actionsQueueService.addAction(request);
  }

  public async commitAndScheduleMeasures(
    inspectionId: InspectionId,
    simplifiedMeasures: SimplifiedMeasurementChecklistMeasuresDTO
  ): Promise<void> {
    await this.commitMeasuresLocally(inspectionId, simplifiedMeasures);
    await this.scheduleMeasuresSync(inspectionId, simplifiedMeasures);
  }

  public async commitMarkedAsNotApplicableLocally(
    inspectionId: InspectionId,
    status: SimplifiedMeasurementChecklistStatusDTO
  ): Promise<void> {
    await this._databaseService.saveSimplifiedMeasuresMarkedAsNotApplicable(inspectionId, status);
    this._store.dispatch(saveSimplifiedMeasuresMarkedAsNotApplicableSuccess({ notApplicable: status.notApplicable }));
  }

  public async scheduleMarkedAsNotApplicableSync(
    inspectionId: InspectionId,
    status: SimplifiedMeasurementChecklistStatusDTO
  ): Promise<void> {
    const url = `${SERVER_API_URL}api/inspections/${inspectionId}/simplified-measurement/status`;
    const request = new HttpRequest<SimplifiedMeasurementChecklistStatusDTO>('PUT', url, status);

    await this._actionsQueueService.addAction(request);
  }

  public async commitAndScheduleMarkedAsNotApplicable(
    inspectionId: InspectionId,
    status: SimplifiedMeasurementChecklistStatusDTO
  ): Promise<void> {
    await this.commitMarkedAsNotApplicableLocally(inspectionId, status);
    await this.scheduleMarkedAsNotApplicableSync(inspectionId, status);
  }
}
